module.exports = __webpack_public_path__ + "static/media/euro-sm.fd329a64.svg";